import { useQuery } from "@tanstack/react-query";

import { getPartnerService } from "./service";

export const getPartnerQueryKey = (id: number | string) => [
  "/v1/partner_admin",
  String(id),
];

export function useGetPartnerQuery(id?: number | string) {
  return useQuery({
    queryKey: getPartnerQueryKey(id ?? ""),
    queryFn: async () => getPartnerService(id as number | string),
    enabled: Boolean(id),
  });
}
